let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");

module.exports = dd.createClass({
	__detach: esUtils.wrapPreventDefault(function(){
		let event = _.cloneDeep(this.props.event);
		event.parentID = 0;
		radio("save_Event").broadcast(event);
		this.props.onClose();
	}),
	render(){
		let {onClose} = this.props;
		return Modal({
				title: "Detach from parent event",
				buttons: [
					{
						name: "No, never mind",
						onClick: onClose,
						className: "btn btn-default"
					},
					{
						name: "Yes, detach",
						onClick: this.__detach,
						className: "btn btn-primary"
					}
				],
				onClose
			},
			dd.p(null,
				"Are you sure you want to detach this event from it's parent event?"
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/ParentChildControls/DetachFromParentModal.js